import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '@src/layout-components/page';
import BaseSwiper from '@src/components/swiper/base-swiper';
import TeamGuestView from './components/team-guest-view';

const styles = require('./index.less');

const assets = {
  'activity-rules.png': require('./images/layers/activity-rules.png'),
  'benefit-draw.png': require('./images/layers/benefit-draw.png'),
  'benefit-free-order.png': require('./images/layers/benefit-free-order.png'),
  'benefit-gold.png': require('./images/layers/benefit-gold.png'),
  'benefit-level.png': require('./images/layers/benefit-level.png'),
  'benefit-month-card.png': require('./images/layers/benefit-month-card.png'),
  'benefit-more.png': require('./images/layers/benefit-more.png'),
  'benefit-retrieve.png': require('./images/layers/benefit-retrieve.png'),
  'cloud-hour.png': require('./images/layers/cloud-hour.png'),
  'gift-1.png': require('./images/layers/gift-1.png'),
  'gift-2.png': require('./images/layers/gift-2.png'),
  'gift-3.png': require('./images/layers/gift-3.png'),
  'gift-4.png': require('./images/layers/gift-4.png'),
  'gift-5.png': require('./images/layers/gift-5.png'),
  'gift-6.png': require('./images/layers/gift-6.png'),
  'gift-7.png': require('./images/layers/gift-7.png'),
  'gift-8.png': require('./images/layers/gift-8.png'),
  'gift-hero-base.png': require('./images/layers/gift-hero-base.png'),
  'gift-shelf.png': require('./images/layers/gift-shelf.png'),
  'gift-title.png': require('./images/layers/gift-title.png'),
  'hero-subtitle.png': require('./images/layers/hero-subtitle.png'),
  'hero-title.png': require('./images/layers/hero-title.png'),
  'logo.png': require('./images/layers/logo.png'),
  'nav-download.png': require('./images/layers/nav-download.png'),
  'nav-feature.png': require('./images/layers/nav-feature.png'),
  'nav-official.png': require('./images/layers/nav-official.png'),
  'reserve-button.png': require('./images/layers/reserve-button.png'),
  'reserve-success.png': require('./images/layers/reserve-success.png'),
  'reserved-heroes.png': require('./images/layers/reserved-heroes.png'),
  'side-navigation-base.png': require('./images/layers/side-navigation-base.png'),
  'side-navigation-reservation-normal.png': require('./images/layers/side-navigation-reservation-normal.png'),
  'side-navigation-reservation-active.png': require('./images/layers/side-navigation-reservation-active.png'),
  'side-navigation-gift-packs-normal.png': require('./images/layers/side-navigation-gift-packs-normal.png'),
  'side-navigation-gift-packs-active.png': require('./images/layers/side-navigation-gift-packs-active.png'),
  'side-navigation-month-card-normal.png': require('./images/layers/side-navigation-month-card-normal.png'),
  'side-navigation-month-card-active.png': require('./images/layers/side-navigation-month-card-active.png'),
  'side-navigation-activity-rules-normal.png': require('./images/layers/side-navigation-activity-rules-normal.png'),
  'side-navigation-activity-rules-active.png': require('./images/layers/side-navigation-activity-rules-active.png'),
  'side-navigation-expand.png': require('./images/layers/side-navigation-expand.png')
};

const image = name => assets[name];

const discountGiftImages = {
  'gift-1': require('./images/layers/gift-1-d.png'),
  'gift-2': require('./images/layers/gift-2-d.png'),
  'gift-3': require('./images/layers/gift-3-d.png'),
  'gift-4': require('./images/layers/gift-4-d.png'),
  'gift-5': require('./images/layers/gift-5-d.png'),
  'gift-6': require('./images/layers/gift-6-d.png'),
  'gift-7': require('./images/layers/gift-7-d.png'),
  'gift-8': require('./images/layers/gift-8-d.png')
};

const giftItems = [
  { id: 'gift-hero', giftId: 1, src: image('gift-hero-base.png'), actionLabel: '创建购买队伍' },
  {
    id: 'gift-1',
    giftId: 2,
    src: image('gift-1.png'),
    actionLabel: '购买特惠礼包',
    bonusHours: 1,
    showPurchaseCount: true
  },
  {
    id: 'gift-2',
    giftId: 3,
    src: image('gift-2.png'),
    actionLabel: '购买超值礼包',
    bonusHours: 1,
    showPurchaseCount: true
  },
  {
    id: 'gift-3',
    giftId: 4,
    src: image('gift-3.png'),
    actionLabel: '购买精致礼包',
    bonusHours: 1,
    showPurchaseCount: true
  },
  {
    id: 'gift-4',
    giftId: 5,
    src: image('gift-4.png'),
    actionLabel: '购买豪华礼包',
    bonusHours: 2,
    showPurchaseCount: true
  },
  {
    id: 'gift-5',
    giftId: 6,
    src: image('gift-5.png'),
    actionLabel: '购买尊享礼包',
    bonusHours: 2,
    showPurchaseCount: true
  },
  { id: 'gift-6', giftId: 7, src: image('gift-6.png'), actionLabel: '购买雷霆印礼包壹', showPurchaseCount: true },
  { id: 'gift-7', giftId: 8, src: image('gift-7.png'), actionLabel: '购买雷霆印礼包贰', showPurchaseCount: true },
  { id: 'gift-8', giftId: 9, src: image('gift-8.png'), actionLabel: '购买雷霆印礼包叁', showPurchaseCount: true }
];

const benefitSections = [
  { id: 'month-card', label: '生态服专属月卡特权', src: image('benefit-month-card.png') },
  { id: 'level-up', label: '生态服专属秒升60级', src: image('benefit-level.png') },
  { id: 'retrieve', label: '生态服专属半价找回', src: image('benefit-retrieve.png') },
  { id: 'gold-set', label: '免费领取黄金套和6技能同伴', src: image('benefit-gold.png') },
  { id: 'anniversary-draw', label: '周年抽奖180万金币', src: image('benefit-draw.png') },
  { id: 'free-order', label: '鸿运当头随机免单', src: image('benefit-free-order.png') },
  { id: 'more-benefits', label: '更多福利', src: image('benefit-more.png') },
  { id: 'activity-rules', label: '活动说明', src: image('activity-rules.png') }
];

const sideNavigation = [
  { target: 'reservation', label: '新服预约', normal: 'side-navigation-reservation-normal.png', active: 'side-navigation-reservation-active.png' },
  { target: 'gift-packs', label: '特惠礼包', normal: 'side-navigation-gift-packs-normal.png', active: 'side-navigation-gift-packs-active.png' },
  { target: 'month-card', label: '生态服专属', normal: 'side-navigation-month-card-normal.png', active: 'side-navigation-month-card-active.png' },
  { target: 'activity-rules', label: '活动说明', normal: 'side-navigation-activity-rules-normal.png', active: 'side-navigation-activity-rules-active.png' }
];

const moreBenefitsSlides = [
  require('./images/swiper-img1.png'),
  require('./images/swiper-img2.png'),
  require('./images/swiper-img3.png'),
  require('./images/swiper-img4.png'),
  require('./images/swiper-img5.png')
];

const Main = () => {
  const store = useStore(() => new MainStore());
  const isSideNavigationInteractive = store.isSideNavigationVisible && !store.isSideNavigationCollapsed;

  if (store.isTeamGuestMode) {
    return (
      <Page className={styles.root}>
        <TeamGuestView store={store} />
      </Page>
    );
  }

  return <Page className={styles.root}>
      <main className={styles.page} aria-label="剑侠世界端游新服预约专题">
        <header className={styles.hero} id="reservation">
          <a className={styles.logo} href="https://jxsj.xoyo.com/" target="_blank" rel="noopener noreferrer" aria-label="剑侠世界端游官网">
            <img src={image('logo.png')} alt="剑侠世界端游" />
          </a>
          <nav className={styles.topNavigation} aria-label="专题导航">
            <a href="https://jxsj.xoyo.com/" target="_blank" rel="noopener noreferrer" onClick={() => store.onOfficialSiteClick()}>
              <img src={image('nav-official.png')} alt="进入官网" />
            </a>
            <a href="//jxsj.xoyo.com/index/download.html" target="_blank" rel="noopener noreferrer" onClick={() => store.onDownloadClick()}>
              <img src={image('nav-download.png')} alt="下载游戏" />
            </a>
            <button type="button" onClick={() => store.onFeatureTopicClick()}>
              <img src={image('nav-feature.png')} alt="资料片专题" />
            </button>
          </nav>
          <img className={styles.heroTitle} src={image('hero-title.png')} alt="预约生态服，领百万绑金" />
          <div className={styles.heroSubtitle}>
            <img className={styles.heroSubtitleArtwork} src={image('hero-subtitle.png')} alt="18周年特别打造首个生态服" />
            <span className={styles.heroServerName}>【{store.serverName}】</span>
            {/*<span className={styles.heroActivityTime}>活动时间：10月8日-11月16日</span>*/}
          </div>
          <div className={styles.heroAccount}>
            {!store.loginStore.isReady ? null : store.loginStore.isLogin ? <React.Fragment>
                {store.loginStore.userName}，
                <button type="button" onClick={store.loginStore.logout}>
                  【退出】
                </button>
              </React.Fragment> : <React.Fragment>
                你好，请
                <button type="button" onClick={store.loginStore.signIn}>
                  【登录】
                </button>
              </React.Fragment>}
          </div>
          <img className={styles.cloudHour} src={image('cloud-hour.png')} alt="送云游戏1小时" />
          <button className={styles.reserveButton} type="button" aria-label={store.isConfigReady ? (store.configViewModel.isReserved ? '已预约' : `预约送绑金${store.configViewModel.bindGoldText}`) : '预约状态加载中'} aria-busy={!store.isConfigReady} disabled={!store.isConfigReady || store.configViewModel.isReserved} data-state={store.configViewModel.reservationState} onClick={() => store.handleReserveClick()}>
            {store.isConfigReady && <img src={image(store.configViewModel.isReserved ? 'reserve-success.png' : 'reserve-button.png')} alt="" />}
          </button>
          <div className={styles.reserveCount}>
            当前预约人数：<strong>{store.reservationCount}</strong>位
          </div>
          <div className={styles.reservedHeroes} aria-label="已预约大侠">
            <img className={styles.reservedHeroesArtwork} src={image('reserved-heroes.png')} alt="" />
            {store.reservationHeroes.length > 0 ? <div className={styles.reservedHeroesViewport}>
                <div className={`${styles.reservedHeroesTrack} ${store.shouldScrollReservationHeroes ? styles.isScrolling : ''}`} style={store.shouldScrollReservationHeroes ? { animationDuration: `${Math.max(16, store.reservationHeroes.length * 2.4)}s` } : undefined}>
                  {store.reservationHeroesLoopItems.map(item => <div className={styles.reservedHeroItem} key={item.id} title={item.displayText}>
                      {item.displayText}
                    </div>)}
                </div>
              </div> : <div className={styles.reservedHeroesEmpty}>暂无数据</div>}
          </div>
        </header>

        <section className={styles.giftSection} id="gift-packs" aria-label="生态服专属特惠礼包">
          <div className={styles.giftTitle}>
            <img className={styles.giftTitleArtwork} src={image('gift-title.png')} alt="生态服专属特惠礼包" />
            <div className={styles.giftSchedule}>
              <p>限新服【{store.serverName}】领取</p>
              <p>特惠时间：10月8日-10月13日 18:00</p>
              <p>补买时间：10月13日18:01-11月16日23:59</p>
            </div>
          </div>
          <img className={styles.giftShelf} src={image('gift-shelf.png')} alt="" />
          <div className={styles.giftList}>
            {giftItems.map(item => {
              const gift = store.giftSlots[item.giftId - 1];
              const action = item.giftId === 1 ? store.mainTeamViewModel : gift;
              return <article className={`${styles.giftItem} ${styles[item.id]}`} key={item.id} data-gift-id={gift.giftId} data-price-phase={gift.pricePhase}>
                  <img src={store.configViewModel.buyStatus === 1 && discountGiftImages[item.id] ? discountGiftImages[item.id] : item.src} alt={gift.name || '特惠礼包'} />
                  <button className={`${styles.giftAction} ${item.id === 'gift-hero' ? styles.teamGiftAction : ''}`} type="button" aria-label={action.actionLabel || item.actionLabel || '购买礼包'} data-label={action.actionLabel} data-state={action.actionState} disabled={item.giftId === 1 ? store.isOrdering || !action.canInteract : gift.isActionDisabled} onClick={() => (item.giftId === 1 ? store.handleTeamGiftClick() : store.handleGiftClick(item.giftId))} />
                  {item.showPurchaseCount && <span className={styles.giftPurchaseCount}>已购买人数：{gift.purchaseCount}</span>}
                </article>;
            })}
          </div>
        </section>

        {benefitSections.map(section => (
          <section className={`${styles.benefitSection} ${styles[section.id]}`} id={section.id} aria-label={section.label} key={section.id}>
            <img src={section.src} alt={section.label} />
            {section.id === 'month-card' && (
              <div className={styles.monthCardDescription}>
                <p>
                  首个生态服专属，激活月卡除月卡福利外，还将在新服【{store.serverName}】获得
                  <strong>对怪物攻击伤害加50%的buff</strong>，
                </p>
                <p>升级效率大大提升，抢夺资源更是快人一步！</p>
              </div>
            )}
            {section.id === 'gold-set' && (
              <div className={styles.goldSetDescription}>
                <p>
                  69级即可<strong>免费获得全套黄金套</strong>，新服【{store.serverName}】自创角起35天内，达到60级且累计签到3天即可获得
                  <strong>6技能同伴-白秋琳！</strong>
                </p>
                <p>
                  还有强者之路、剑侠征程<strong>海量材料、玄晶、绑金、珍珠贝</strong>等好礼助阵大侠征战新服！
                </p>
              </div>
            )}
            {section.id === 'anniversary-draw' && (
              <div className={styles.drawDescription}>
                <p className={styles.drawActivityTime}>活动时间：10月13日-11月7日23:59</p>
                <div className={styles.drawRules}>
                  <p>根据10月13日-11月7日期间累计消费金额可领取对应数量的财运红包，</p>
                  <p>每档限领1次不可重复领取（参与购买“特惠礼包”的大侠，可在新服【{store.serverName}】领取所购礼包时</p>
                  <p>获得对应特惠礼包金额的消耗积分）。</p>
                </div>
              </div>
            )}
            {section.id === 'more-benefits' && (
              <React.Fragment>
                <div className={styles.moreBenefitsDescription}>
                  <p>
                    10月13日起，关注“剑侠世界端游”、“剑世福利官”微信号可分别领取
                    <span className={styles.moreBenefitsHighlight}>新服[VIP礼包]</span>以及
                    <span className={styles.moreBenefitsHighlight}>[侠聚华年福利官礼包]</span>，
                  </p>
                  <p>内含大量珍珠贝、绑金、玄晶等好礼，礼包数量有限先到先得！</p>
                  <p>
                    10月8日-10月13日期间参与<span className={styles.moreBenefitsHighlight}>新服预创建</span>，开服将获得价值200元的开服礼包！
                  </p>
                </div>
                <div className={styles.moreBenefitsCarousel} aria-label="更多福利轮播图">
                  <BaseSwiper store={store.moreBenefitsSwiper}>
                    {moreBenefitsSlides.map((slide, index) => (
                      <div className={styles.moreBenefitsSlide} key={slide}>
                        <img className={index === 2 ? styles.moreBenefitsCroppedSlide : ''} src={slide} alt={`更多福利${index + 1}`} />
                      </div>
                    ))}
                  </BaseSwiper>
                </div>
              </React.Fragment>
            )}
            {section.id === 'activity-rules' && (
              <div className={styles.activityRulesContent}>
                <section className={styles.ruleGroup}>
                  <h3>一、新服预约</h3>
                  <p>活动时间：10月8日-11月16日23:59</p>
                  <p>
                    ·通过绑定身份证和手机验证的大侠，可在新服<strong>【{store.serverName}】</strong>开服后领取
                    <strong>
                      {/*{store.configViewModel.bindGoldText}*/}
                      35万绑金+云游戏1小时时长。
                    </strong>
                  </p>
                  <p>同1个绑定身份证或绑定手机下仅可验证1个账号，一经验证不可取消。</p>
                </section>

                <section className={styles.ruleGroup}>
                  <h3>二、特惠礼包</h3>
                  <p>特惠价时间：10月8日-10月13日18:00</p>
                  <p>补买价时间：10月13日18:01-11月16日23:59</p>
                  <p>
                    特惠、补买时间所购礼包内容相同，但价格不同，<strong>补买价格高于特惠价格</strong>（钜惠团购礼包价格不变）。
                  </p>
                  <p>
                    ·钜惠组队礼包、特惠礼包、超值礼包、精致礼包、豪华礼包、尊享礼包、雷霆印礼包壹、雷霆印礼包贰和雷霆印礼包叁九种超值礼包，
                    登陆账号后即可购买。<strong>每个账号每种礼包限购1次</strong>，同种礼包多次购买为无效购买，因超低折扣不予退款，请谨慎购买！
                  </p>
                  <p>
                    ·钜惠组队礼包两人组队购买，可额外获得<strong>御赐仙鹤绣金囊[18格]</strong>奖励！大侠点击“创建购买队伍”购买成功后，将生成专属邀请链接，
                    分享好友，好友通过邀请链接“加入购买队伍”完成购买，即两人组队购买成功。
                  </p>
                  <p>
                    ·未完成实名认证的账号请<strong>“点击”</strong>完成实名认证后参与购买；如遇支付码失效，可稍作等待后刷新页面再尝试支付。
                  </p>
                  <p>·支付订单有效期2分钟，有效期内不可切换双端支付。</p>
                </section>

                <section className={styles.ruleGroup}>
                  <h3>三、领奖说明</h3>
                  <p>领奖时间：10月13日-11月19日23:59</p>
                  <p>礼包有效期截止：11月30日23:59</p>
                  <p>
                    领奖方式：新服<strong>【{store.serverName}】</strong>点击游戏画面顶部<strong>“开服狂欢”-“百万绑金”和“预约好礼”</strong>界面领取。
                  </p>
                  <p>·参与新服预约、购买特惠礼包的账号，限在领奖时间内激活账号下1个角色领取对应奖励，激活角色唯一。</p>
                  <p>
                    <strong>·通过此活动获得的绑金将根据开服天数和等级进行分次领取。</strong>
                  </p>
                  <p>
                    <strong>
                      ·奖励内容均为绑定，不支持更换账号及角色领取，且限账号下1个角色领取。当角色确认领取后，绑金及礼包的领取资格将不可更换，
                      每种礼包最多领取1次，不可多次领取，未领取完奖励的大侠请不要进行角色交易，会导致奖励无法领取，且不作退还！
                    </strong>
                  </p>
                </section>

                <p className={styles.ruleFooter}>以上内容仅供参考，具体以游戏内实际情况为准！</p>
              </div>
            )}
          </section>
        ))}

        <nav className={`${styles.sideNavigation} ${store.isSideNavigationVisible && !store.isSideNavigationCollapsed ? styles.sideNavigationVisible : ''}`} aria-label="页面快捷导航" aria-hidden={!isSideNavigationInteractive}>
          <img className={styles.sideNavigationBase} src={image('side-navigation-base.png')} alt="" />
          <button className={styles.sideNavigationCollapse} type="button" aria-label="收起菜单" tabIndex={isSideNavigationInteractive ? 0 : -1} onClick={store.collapseSideNavigation} />
          <div className={styles.sideLinks}>
            {sideNavigation.map(item => {
              const isActive = store.activeSideNavigationTarget === item.target;
              return <button type="button" aria-label={item.label} aria-current={isActive ? 'true' : undefined} tabIndex={isSideNavigationInteractive ? 0 : -1} key={item.target} onClick={() => store.onSideNavigationClick(item.target, item.label)}>
                  <img className={`${styles.sideNavigationStateNormal} ${isActive ? styles.sideNavigationStateHidden : styles.sideNavigationStateVisible}`} src={image(item.normal)} alt="" />
                  <img className={`${styles.sideNavigationStateActive} ${isActive ? styles.sideNavigationStateVisible : styles.sideNavigationStateHidden}`} src={image(item.active)} alt="" />
                  <span className={styles.srOnly}>{item.label}</span>
                </button>;
            })}
          </div>
          <button className={styles.sideNavigationBackTop} type="button" aria-label="返回顶部" tabIndex={isSideNavigationInteractive ? 0 : -1} onClick={store.backToTop} />
          <a className={styles.sideNavigationCloudGame} href="https://jxsj.xoyo.com/zt/2021/02/23/yunyouxi/index.html" target="_blank" rel="noopener noreferrer" aria-label="送云游戏时长" tabIndex={isSideNavigationInteractive ? 0 : -1} onClick={store.onCloudGameClick}>
            <span className={styles.srOnly}>送云游戏时长</span>
          </a>
        </nav>
        <button className={`${styles.sideNavigationExpand} ${store.isSideNavigationVisible && store.isSideNavigationCollapsed ? styles.sideNavigationExpandVisible : ''}`} type="button" aria-label="展开菜单" aria-hidden={!store.isSideNavigationVisible || !store.isSideNavigationCollapsed} tabIndex={store.isSideNavigationVisible && store.isSideNavigationCollapsed ? 0 : -1} onClick={store.expandSideNavigation}>
          <img src={image('side-navigation-expand.png')} alt="" />
        </button>
      </main>
    </Page>;
};

export default observer(Main);
